"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDecimalPrecision = void 0;
var toDecimalPrecision = function (input, allLength) {
    var _a;
    var inputArray = input.split(".");
    var integer = inputArray[0];
    var decimal = (_a = inputArray[1]) === null || _a === void 0 ? void 0 : _a.slice(0, allLength - inputArray[0].length);
    return "".concat(integer).concat(decimal ? "." : "").concat(decimal || "");
};
exports.toDecimalPrecision = toDecimalPrecision;
//# sourceMappingURL=trim.js.map